import { TokenAdmService } from './token-adm.service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Usuario } from '../models/usuario-response';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { map, tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

const GRAPH_ENDPOINT = `${environment.graphApiURL}/me`;

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  public usuario: Usuario;

  private httpPublicClient: HttpClient;

  constructor(
    private http: HttpClient,
    private HttpBackend: HttpBackend,
    private token: TokenAdmService
  ) {
    this.httpPublicClient = new HttpClient(HttpBackend);
  }

  private createImageFromBlob(image: Blob) {
    return new Promise<string | ArrayBuffer>((resolve, reject) => {
      const reader = new FileReader();

      reader.addEventListener(
        'load',
        () => {
          resolve(reader.result);
        },
        false
      );
      if (image) {
        reader.readAsDataURL(image);
      }
    });
  }

  private obtenerUser() {
    if (this.token.hayCuentaActiva()) {
      let usuario: any;
      try {
        usuario = this.http.get<Usuario>(GRAPH_ENDPOINT).toPromise();
      } catch (error) {
      } finally {
        return usuario;
      }
    }
  }

  private obtenerFoto() {
    return this.http
      .get(encodeURI(`${GRAPH_ENDPOINT}/photo/$value`), {
        responseType: 'blob',
      })
      .pipe(
        map(async (image) => {
          //  console.log('imagen: ', image);
          return await this.createImageFromBlob(image);
        })
      )
      .toPromise();
  }

  async getUsuario() {
    let foto: any = null;
    const usr = await this.obtenerUser();
    if (usr) {
      try {
        foto = await this.obtenerFoto();
      } catch (error) {
        foto = null;
      } finally {
        if (usr) {
          this.usuario = new Usuario(
            usr.displayName,
            usr.mail,
            foto?.toString(),
            usr.userPrincipalName
          );
        }
      }
    }
  }
}
